export default __webpack_public_path__ + "static/media/cod-modern-warfare.1c485271.png";